// extracted by mini-css-extract-plugin
export default {"placeholder":"AppStore_placeholder__ChG5D"};